// Parse numbers, unary signs, parentheses and the four basic operators without eval.
export function evaluateCalculator(expression) {
  let position = 0;
  const atom = () => {
    if (expression[position] === "+" || expression[position] === "-") {
      const sign = expression[position++] === "-" ? -1 : 1;
      return sign * atom();
    }
    if (expression[position] === "(") {
      position += 1;
      const value = sum();
      if (expression[position++] !== ")") throw new Error("Missing parenthesis");
      return value;
    }
    const number = expression.slice(position).match(/^(?:\d+(?:\.\d*)?|\.\d+)/);
    if (!number) throw new Error("Missing number");
    position += number[0].length;
    return Number(number[0]);
  };
  const product = () => {
    let value = atom();
    while (expression[position] === "*" || expression[position] === "/") {
      const operator = expression[position++];
      const right = atom();
      value = operator === "*" ? value * right : value / right;
    }
    return value;
  };
  const sum = () => {
    let value = product();
    while (expression[position] === "+" || expression[position] === "-") {
      const operator = expression[position++];
      const right = product();
      value = operator === "+" ? value + right : value - right;
    }
    return value;
  };
  const result = sum();
  if (position !== expression.length || !Number.isFinite(result)) throw new Error("Invalid expression");
  return String(Number(result.toFixed(6)));
}

export function inputCalculator(current, key) {
  if (key === "C") return "0";
  if (current === "Error") current = "0";
  const negative = current.match(/\(-((?:\d+(?:\.\d*)?|\.\d+))\)$/);
  if (key === "+/−") {
    if (negative) return current.slice(0, negative.index) + negative[1];
    const number = current.match(/(?:\d+(?:\.\d*)?|\.\d+)$/);
    if (!number) return current + "(-0)";
    const prefix = current.slice(0, number.index);
    if (prefix === "-") return number[0];
    return prefix + "(-" + number[0] + ")";
  }
  if (key === "⌫") {
    if (negative) {
      const prefix = current.slice(0, negative.index);
      const number = negative[1].slice(0, -1);
      return number ? prefix + "(-" + number + ")" : prefix || "0";
    }
    const next = current.slice(0, -1);
    return next && next !== "-" ? next : "0";
  }
  if (/^[0-9.]$/.test(key)) {
    if (negative) {
      if (key === "." && negative[1].includes(".")) return current;
      const number = negative[1] === "0" && key !== "." ? key : negative[1] + key;
      return current.slice(0, negative.index) + "(-" + number + ")";
    }
    const number = current.match(/(?:\d+(?:\.\d*)?|\.\d+)$/);
    if (key === "." && number && number[0].includes(".")) return current;
    if (current === "0" && key !== ".") return key;
    return current + (key === "." && !number ? "0." : key);
  }
  if (/^[+\-*/]$/.test(key)) return current.replace(/[+\-*/]$/, "") + key;
  return current;
}
